import type { ScheduleConfig, TaskSchedule } from "../api/requests";

const WEEK_DAY_LABELS: Record<number, string> = {
  1: "понедельник",
  2: "вторник",
  3: "среда",
  4: "четверг",
  5: "пятница",
  6: "суббота",
  7: "воскресенье",
};

export const getActiveTaskSchedule = (
  schedules: TaskSchedule[] | undefined
): TaskSchedule | null => {
  if (!schedules?.length) return null;

  const activeSchedule = schedules.find((item) => !item.status || item.status === "active");
  return activeSchedule ?? schedules[0] ?? null;
};

export const formatSchedulePeriodicity = (
  schedule: ScheduleConfig | undefined | null
): string | null => {
  if (!schedule?.period) return null;

  switch (schedule.period) {
    case "daily":
      return "Ежедневно";
    case "weekly": {
      const weekDay = schedule.weekDay ?? 1;
      const label = WEEK_DAY_LABELS[weekDay];
      return label ? `Раз в неделю, ${label}` : "Раз в неделю";
    }
    case "monthly": {
      const day = schedule.day ?? 1;
      if (day >= 31) return "Раз в месяц, в последний день";
      return `Раз в месяц, ${day}-го числа`;
    }
    default:
      return null;
  }
};

export const formatTaskSchedulePeriodicity = (
  schedules: TaskSchedule[] | undefined
): string | null => {
  const scheduleItem = getActiveTaskSchedule(schedules);
  if (!scheduleItem?.schedule) return null;

  return formatSchedulePeriodicity(scheduleItem.schedule);
};
